import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { USER_ROLES } from '../../firebase/config';

export default function RoleRoute({ children, allowedRoles }) {
  const { currentUser, userProfile } = useAuth();

  if (!currentUser) {
    return <Navigate to="/login" />;
  }

  if (!userProfile) {
    return <div>Caricamento...</div>;
  }

  if (!allowedRoles.includes(userProfile.role)) {
    return <Navigate to="/unauthorized" />;
  }

  return children;
} 